<template>
  <AccordionItem
    :is-open-on-desktop="true"
    class="filter-accordion-legacy"
  >
    <template #title> Filtern und sortieren</template>
    <template #content>
      <FilterForm
        :variables="variables"
        :aggregations="aggregations"
        class="filter-accordion-legacy__content"
        :item-urls="itemUrls"
        :cross-category="crossCategory"
        :hidden-filters="hiddenFilters"
        :current-offers-count="currentOffersCount"
        :hide-sort-dropdown="hideSortDropdown"
        @submit="onSubmit"
      >
        <template #additionalToggle>
          <slot name="additionalToggle" />
        </template>
        <template #additionalFilters>
          <slot name="additionalFilters" />
        </template>
      </FilterForm>
    </template>
  </AccordionItem>
</template>

<script>
import FilterForm from '~/components/filter/filter-form.vue';
import { AccordionItem } from '@i22team/td-longtail-vue-components';

export default {
  name: 'FilterAccordion',
  components: {
    FilterForm,
    AccordionItem,
  },
  props: {
    hasOffers: {
      type: Boolean,
      default: false,
    },
    variables: {
      type: Object,
      required: true,
    },
    aggregations: {
      type: Object,
      required: true,
    },
    itemUrls: {
      type: Object,
      default: () => ({}),
    },
    crossCategory: {
      type: Boolean,
    },
    hiddenFilters: {
      type: Array,
      default: () => [],
    },
    hideSortDropdown: {
      type: Boolean,
      default: false,
    },
    currentOffersCount: {
      type: Number,
      default: null,
    },
  },
  emits: ['submit'],
  methods: {
    onSubmit(data) {
      this.$emit('submit', data);
    },
  },
};
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.filter-accordion-legacy {
  margin-bottom: $grid-base * 0.5;
  padding: 0;
  border-top: 1px solid var(--color-stroke-subtle);
  border-bottom: 1px solid var(--color-stroke-subtle);

  &.accordion-item--inactive-desktop:deep(.accordion-item__title) {
    @include mq($mq-md) {
      display: none;
    }
  }

  :deep(.accordion-item__panel) {
    // disable, will cut the select dropdown.
    perspective: none;
    transform: none;
  }

  :deep(.accordion-item__content) {
    padding: 0;
  }

  &__content {
    background-color: rgb(from var(--color-background-subtle) r g b / 0.4);
  }
}
</style>
